import React, { useMemo } from 'react';

import { EPriceTypes } from '@r1-frontend/shared/types/EPriceTypes';

import Benefits from '~/src/features/yandex-landing/Benefits';
import type { IBonusBanner } from '~/src/features/yandex-landing/BonusBanner/types';
import { priceData } from '~/src/features/yandex-landing/data';
import type { TPriceData } from '~/src/features/yandex-landing/data/types';
import FeedbackForm from '~/src/features/yandex-landing/FeedbackForm';

import * as ST from './styled';

const PriceBlock: React.FC<IBonusBanner> = ({ stationLight, city }) => {

    const createComponent = ({ tag, text }: Required<TPriceData>['componentProps']): JSX.Element => {
        return React.createElement(tag, null, text);
    };

    const currentPrice = useMemo(
        () => stationLight.pricesV2?.find(({ type }) => type === EPriceTypes.Possess)?.value,
        [stationLight],
    );

    return (
        <ST.PriceBlock>
            <ST.FirstLine>
                <Benefits/>
                <ST.PriceRow>
                    {priceData.map(({ id, title, price, componentProps }) => (
                        <ST.PriceContainer key={id}>
                            <ST.PriceText>
                                {title}
                                {componentProps && createComponent(componentProps)}
                            </ST.PriceText>
                            <ST.CurrentPrice>{price || currentPrice + ' ₽'}</ST.CurrentPrice>
                        </ST.PriceContainer>
                    ))}
                </ST.PriceRow>
            </ST.FirstLine>
            <FeedbackForm
                city={city}
                Container={ST.SecondLine}
                InputPhoneComponent={ST.InputPhone}
                ButtonComponent={ST.BannerButton}
                buttonTitle={'Хочу Яндекс.Станцию'}
                withoutName
                withoutAgreement
            />
        </ST.PriceBlock>
    );
};

export default PriceBlock;
